export default __webpack_public_path__ + "static/media/FinishedConversations.b0b6d399.svg";